import React, { Component } from 'react';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import Button from '../../UI/Button/Button';
import TooltipError from '../../UI/TooltipError/TooltipError';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

import InputMaterial from '../../UI/InputMaterial/InputMaterial';

import TextSpinner from '../../UI/TextSpinner/TextSpinner';

import * as authActions from '../../../store/actions/index.js';

class AuthHome extends Component  {

    state = {
        userInput: '',
        invalidError: false
    }

    inputChangeHandler = (event) => {
        this.setState({ userInput: event.target.value })
    }

    onClickHandler = () => {
        let regex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let validatedEmail = regex.test(String(this.state.userInput.trim()).toLowerCase());
        if (this.state.userInput.trim() === '' || !validatedEmail) {
            this.setState({ invalidError: true })
        } else {
            this.setState({ invalidError: false })
            this.props.onAuthValidityCheck(this.state.userInput);
        }   
    }

    keyPressHandler = (event) => {
        if(event.key === 'Enter') {
            this.onClickHandler();
        }
    }

    render() {
        const border = '1px solid var(--color-border)';
        return (
            <React.Fragment>
                <div className={`mb-10`}>
                    <HeadingBox>
                        <div className={`mb-2 u-phoneTextAlignCenter`}>
                            <div className="mb-1">
                                <HeadingH2 size={26} weight="Regular" color="Dark">Login to Traverse</HeadingH2>
                            </div>
                            <div className="mb-1">
                                <HeadingH2 size={26} weight="Regular" color="Dark">Business to Business</HeadingH2>
                            </div>
                        </div>
                        <HeadingH3 size={13} weight="Regular" color="Light">Enter your registered B2B Email ID to login</HeadingH3>
                    </HeadingBox>
                </div>
                <div className={`u-flex align-items-center u-relative u-height60 mb-10`}>
                    <TooltipError showTooltip={this.props.validityError || this.state.invalidError} type="loginError" aria-label={this.state.invalidError ? "Please enter a valid Email ID to proceed." : "This isn't a valid B2B user Email ID. Switch to the correct channel by using the link(s) below"} />
                    <InputMaterial 
                        type='text' 
                        label='B2B Email ID' 
                        alignment='left' 
                        value={this.state.userInput}
                        onChange={this.inputChangeHandler}
                        onKeyPress={this.keyPressHandler}
                        style={{borderBottom: this.props.validityError ? '2px solid #FC1D00' : `${border}`}} />
                </div>
                <div className={`mb-12`}>
                    <Button theme='Primary' type='Continue' width='Block' onClick={this.onClickHandler}>{ this.props.validityLoading ? <TextSpinner type='White'/> : 'Continue' }</Button>
                </div>
                <div className={`mb-4 u-textAlignCenter`}>
                    <p className={`u-fontSize16 u-textColorDark`}>Not registered yet?</p>
                </div>
                <div>
                    <Button theme='OutlinePrimary' type='Continue' width='Block' onClick={() => {
                        window.open('https://secure.yatra.com/partnersv3/b2b/register_user.html', "_blank");
                    }}>Register Now</Button>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        validityError: state.auth.authValidityError,
        validityLoading: state.auth.authValidityLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuthValidityCheck: (userInput) => dispatch(authActions.authValidityCheck(userInput))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthHome);



// WEBPACK FOOTER //
// ./src/components/Authentication/AuthHome/AuthHome.js